/**
 * Common implementation for Monetate.
 */

/**
 * Function to load script
 */
jQuery.loadScriptNerd = function (url, callback) {
    jQuery.ajax({
        url: url,
        dataType: 'script',
        success: callback,
        async: true
    });
}



function monetateTrackPlp(){
    window.monetateQ = window.monetateQ || [];
    var productList=[];
		$.each(tealiumProducts, function(index, value) { 
			//var itemDetail = [{productId:""}];
			//itemDetail.productId=index;
			productList.push(value.UPC);
		  });
		 window.monetateQ.push(["addProducts", productList]);
		 window.monetateQ.push(["addCategories",[pageSection_1]]);
		 window.monetateQ.push(["setPageType", "catalog"]);
	 
		 //update monetate cart
		 if(itemsInCartBadge!==""){
			 monetateTrackCart("catalog", []);
		 }else{
			 window.monetateQ.push(["trackData"])
		 }
	
   
	

}


function monetateTrackPage(pageType){	
		monetateTrackCart(pageType,[]); 
}


function monetateTrackProduct(currentProductId,sku,category){
        var productDetails=[];
		var pdpDetail = [{productId:"",sku:""}];
		pdpDetail.productId=currentProductId;
        pdpDetail.sku=sku;
	    productDetails.push(pdpDetail);
		window.monetateQ = window.monetateQ || [];
		window.monetateQ.push(["addCategories",[category]]);
		window.monetateQ.push(["addProductDetails",productDetails]);
		window.monetateQ.push(["setPageType","product"]);
		window.monetateQ.push(["trackData"]);
} 

/**
 * Update the already existent Monetate variables with the Cart Products information.
 */
function updateOrdersInMonetate(pageType) {
    
    if (typeof Promise.each == 'undefined') $.loadScriptNerd('/wcsstore/Common/ThirdPartyLibraries/bluebird/bluebird.min.js', function(){
        console.log("Reloading bluebird");
    });
    
    if (!window.monetateCartProducts) {
        window.monetateCartProducts = [];
    }
    var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self";
    
    if(personInfo === undefined || personInfo.userId !== '-1002'){
	    getAjaxPromise(url)
	    .then(function(orderData) {
	        if(orderData.orderItem) {
	            Promise.each(orderData.orderItem, function(item) {
	                var urlCatentry = "/wcs/resources/store/" + WCParamJS.storeId + "/productview/byId/" + item.productId;
	                return getAjaxPromise(urlCatentry)
	                    .then(function(catentryData) {
	                        var catEntry = catentryData.CatalogEntryView[0];
	                        var productName = catEntry.name;
	                        if (productName == undefined || productName.length == 0) {
	                            productName = item.partNumber;
	                        }
	                        window.monetateCartProducts.push({
	                            productId: productName,
	                            quantity: 1,
	                            unitPrice: parseFloat(item.unitPrice),
	                            currency: env_currencyCode,
	                        });
	                    }).catch(function(rejection) {
	                        if (engravingProductId && item.productId == engravingProductId) {
	                            window.monetateCartProducts.push({
	                                productId: "814617708100",
	                                quantity: 1,
	                                unitPrice: parseFloat(engravingPriceJSTL),
	                                currency: env_currencyCode,
	                            });
	                        }
	                    });
	            }).then(function(result) {
	                pushMonetateTrackInfo(pageType)
	            }).catch(function(rejection) {
	                pushMonetateTrackInfo(pageType)
	            });
	        }
	    }).catch(function(rejection) {
	        pushMonetateTrackInfo(pageType)
	    });
    }
}

/**
 * Update the already existent Monetate variables with the Cart Products information, adding extra Monetate parameters.
 */
function monetateTrackCart(pageType, monetateData) {
    
    if (typeof Promise.each == 'undefined') $.loadScriptNerd('/wcsstore/Common/ThirdPartyLibraries/bluebird/bluebird.min.js', function(){
        console.log("Reloading bluebird");
    });
    
    if (!window.monetateCartProducts) {
        window.monetateCartProducts = [];
    }
    var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self";
    
    if(personInfo === undefined || personInfo.userId !== '-1002'){
	    getAjaxPromise(url)
	    .then(function(orderData) {
	        if(orderData.orderItem !== undefined) {
	            Promise.each(orderData.orderItem, function(item) {
	                var urlCatentry = "/wcs/resources/store/" + WCParamJS.storeId + "/productview/byId/" + item.productId;
	                return getAjaxPromise(urlCatentry)
	                    .then(function(catentryData) {
	                        var catEntry = catentryData.CatalogEntryView[0];
							var productName = catEntry.partNumber;
	                        if (productName == undefined || productName.length == 0) {
	                            productName = item.partNumber;
							}
							
	                        window.monetateCartProducts.push({
	                            productId: productName,
	                            quantity: 1,
	                            unitPrice: parseFloat(item.unitPrice),
	                            currency: env_currencyCode,
	                        });
	                    }).catch(function(rejection) {
	                        if (engravingProductId && item.productId == engravingProductId) {
	                            window.monetateCartProducts.push({
	                                productId: "814617708100",
	                                quantity: 1,
	                                unitPrice: parseFloat(engravingPriceJSTL),
	                                currency: env_currencyCode,
	                            });
	                        }
	                    });
	            }).then(function(result) {
	                pushMonetateTrackInfo(pageType, monetateData)
	            }).catch(function(rejection) {
	                pushMonetateTrackInfo(pageType, monetateData)
	            });
	        }
	        else {
	        	pushMonetateTrackInfo(pageType, monetateData)
	        }
	    }).catch(function(rejection) {
	        pushMonetateTrackInfo(pageType, monetateData)
	    });
    }
    else {
    	pushMonetateTrackInfo(pageType)
    }
}

/**
 * Create and push the "track" entity to Monetate.
 */
function pushMonetateTrackInfo(pageType, monetateData) {
    if (window.monetateQ) {
        window.monetateQ.push(["setPageType", pageType]);
        if (window.monetateCartProducts && window.monetateCartProducts.length > 0) {
            window.monetateQ.push(["addCartRows", window.monetateCartProducts]);
        }
        if (monetateData) {
            $.each(monetateData, function(index, value) {
                window.monetateQ.push([value[0], value[1]]);
            });
        }
        window.monetateQ.push(["trackData"]);
    }
}


/**
 * Check the page type towards the meta information (NOT IN USE).
 */
function checkMonetatePageType() {
    var metaPageGroup = $('meta[name=pageGroup]').attr("content");
    var metaPageIdentifier = $('meta[name=pageIdentifier]').attr("content");
    
    if ("Category".equalsIgnoreCase(metaPageGroup)) {
        // PLP
        pageType = "category";
    } else if ("Product".equalsIgnoreCase(metaPageGroup)) {
        // PDP
        pageType = "product";
    } else if ("content".equalsIgnoreCase(metaPageGroup)) {
        if ("HomePage".equalsIgnoreCase(metaPageIdentifier)) {
            // HomePage
            pageType = "home";
        } else {
            // Editorial
            pageType = "editorial";
        }
	}
	
    
    return pageType;
}
